import { PROJECT_NAME, COL_PROJECT_NAME } from "./field/project_name";
import { PROPERTY_TYPE, COL_PROPERTY_TYPE, COL_MODAL_PROPERTY_TYPE } from "./field/property_type";
import { LOCATION, COL_LOCATION, COL_MODAL_LOCATION } from "./field/location";
import { TENURE, COL_TENURE, COL_MODAL_TENURE } from "./field/tenure";
import { COMPLETION_DATE, COL_COMPLETION_DATE, COL_MODAL_COMPLETION_DATE } from "./field/completion_date";
import { BEDROOM, COL_BEDROOM, COL_MODAL_BEDROOM } from "./field/bedroom";
import { PRICE_MIN, PRICE_MAX, COL_PRICE_MIN, COL_PRICE_MAX, COL_MODAL_PRICE_MIN, COL_MODAL_PRICE_MAX } from "./field/price";
import { CLEAR_BUTTON, SUBMIT_BUTTON, COL_CLEAR_SUBMIT_BUTTON } from "./field/button";

const getSearchFields = () => {

  return [
    PROJECT_NAME,
    PROPERTY_TYPE,
    LOCATION,
    TENURE,
    COMPLETION_DATE,
    BEDROOM,
    PRICE_MIN,
    PRICE_MAX,
  ];

}

const getSearchFormConfig = ({ search_type }) => {

  const MOBILE_FORM = [
    {
      id: "row_1",
      type: "row",
      props: {
        className: "gy-2 d-flex flex-fill"
      },
      children: [
        {
          id: "col",
          type: "col",
          props: {
            className: "",
          },
          children: [
            PROJECT_NAME,
          ]
        },
        {
          id: "col_2",
          type: "col",
          props: {
            className: "d-flex align-items-center justify-content-end",
            xs: "auto",
            style: {
              width: 60
            }
          },
          children: [
            {
              id: "modal",
              type: "modal",
              children: [
                {
                  id: "container",
                  type: "container",
                  props: {
                    fluid: true,
                    className: "search-form d-flex flex-column gap-2"
                  },
                  children: [
                    {
                      id: "row_1",
                      type: "row",
                      props: {
                        className: "gy-2 d-flex flex-fill"
                      },
                      children: [
                        COL_MODAL_PROPERTY_TYPE,
                        COL_MODAL_LOCATION,
                        COL_MODAL_TENURE,
                        COL_MODAL_COMPLETION_DATE,
                        COL_MODAL_BEDROOM,
                      ]
                    },
                    {
                      id: "row_2",
                      type: "row",
                      props: {
                        className: "gy-2 d-flex flex-fill"
                      },
                      children: [
                        COL_MODAL_PRICE_MIN,
                        COL_MODAL_PRICE_MAX,
                      ]
                    },
                    {
                      id: "row_3",
                      type: "row",
                      props: {
                        className: "gy-2 d-flex flex-fill"
                      },
                      children: [
                        COL_CLEAR_SUBMIT_BUTTON
                      ]
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    }
  ];

  const DESKTOP_FORM = [
    {
      id: "row_1",
      type: "row",
      props: {
        className: "gy-2 d-flex flex-fill"
      },
      children: [
        COL_PROJECT_NAME,
        COL_PROPERTY_TYPE,
        COL_LOCATION,
        COL_TENURE,
        COL_COMPLETION_DATE,
        COL_BEDROOM,
        COL_PRICE_MIN,
        COL_PRICE_MAX,
      ]
    },
    {
      id: "row_2",
      type: "row",
      props: {
        className: "gy-2 d-flex flex-fill"
      },
      children: [
        COL_CLEAR_SUBMIT_BUTTON
      ]
    }
  ];

  const MOBILE = {
    id: "mobile",
    type: "div",
    props: {
      className: "d-flex flex-column d-sm-none mobile"
    },
    children: MOBILE_FORM
  };

  const DESKTOP = {
    id: "desktop",
    type: "div",
    props: {
      className: "d-none d-sm-flex flex-column desktop"
    },
    children: DESKTOP_FORM
  };

  // TODO: Hook here

  if (search_type === "map") {
    return MOBILE_FORM;
  }

  return [{
    id: "form",
    type: "div",
    children: [
      MOBILE,
      DESKTOP
    ]
  }];

}

export { getSearchFields, getSearchFormConfig };
